import React from 'react';
import type { ComponentProps } from 'react';

import BsaLogo from '../../../../assets/images/BSAColorLogo.svg';

interface MBImageProps extends ComponentProps<'img'> {}

export default function MBImage(props: MBImageProps) {
  const src = props.src;
  if (!src) return <BsaLogo {...props} />;

  return <img {...props} src={src} />;
}
